"use client";

import styles from "./styles.module.css";
import { useLocale } from "next-intl";
import Link from "next-intl/link";
import { MenuItemProps } from "types/MenuItem.type";

export default function MenuItem({
  title,
  isActive,
  href,
  style,
  isSubmenu,
  setExpandMenu,
}: MenuItemProps) {
  const locale = useLocale();
  return (
    <Link
      href={href}
      locale={locale}
      title='Menu item'
      onClick={() => setExpandMenu(false)}
      className={`${styles["nav__menu-item"]} ${
        styles["nav__menu-item--color"]
      } ${
        isActive
          ? (isSubmenu ? styles["nav__submenu-item--active"] : styles["nav__menu-item--active"])
          : (isSubmenu ? styles["nav__submenu-item--decoration"] : styles["nav__menu-item--decoration"])
      } ${style || ""}`}
    >
      {title}
    </Link>
  );
}
